import AscFleetDataContainer from './containers/AscFleetDataContainer'
import { role } from '@/utilities/userRoles'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

const fleetDataRouter = {
  icon: 'mdi-airplane',
  path: '/fleet',
  name: 'Fleet',
  display: true,
  component: AscFleetDataContainer,
  meta: {
    primaryNavigation: AppFeatureFlags.getFleetDataPage(),
    requiresRole: [role.airlineUser, role.acmfUser],
    tooltip: 'View fleet health',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Fleet',
      },
    ],
  },
  children: [],
}

export default fleetDataRouter
